<rappider-title-toolbar [mainTitle]="mainTitle"
                        [options]="title"
                        [displayToolbar]="displayToolbar"
                        [displayToolbarBackButton]="displayToolbarBackButton"></rappider-title-toolbar>

<rappider-workflow-step-function-form [data]="workflowStepFunction"
                                      [formLayout]="editFormConfig.formLayout"
                                      [isSubmitButtonFloat]="editFormConfig.isSubmitButtonFloat"
                                      (workflowStepFunctionFormSubmit)="onEditWorkflowStepFunction($event)"></rappider-workflow-step-function-form>
